import { render, staticRenderFns } from "./ClientesCRUD.vue?vue&type=template&id=37b1c694"
import script from "./ClientesCRUD.vue?vue&type=script&lang=js"
export * from "./ClientesCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports